import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getters, actions } from "../model";

const decorate = connect(
  state => ({
    loading: getters.loading(state),
    errorMessage: getters.errorMessage(state)
  }),
  {
    init: actions.init
  }
);

const Layout = ({ init, params, location, errorMessage }) => {
  useEffect(() => {
    init({
      eventUUID: params.eventUUID,
      accountId: params.accountId,
      email: location.query.email
    });
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh"
      }}
    >
      <div
        style={{
          textAlign: "center",
          padding: "20px",
          borderRadius: "15px",
          backgroundColor: "#f4f4f4",
          fontSize: "16px",
          color: "#000",
          width: "600px"
        }}
      >
        {errorMessage ? errorMessage : "Loading..."}
      </div>
    </div>
  );
};

export default decorate(Layout);
